exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/_object-gops.js
// module id = 65
// module chunks = 99